module.exports = __webpack_public_path__ + "static/media/rightOutputGain.cfbf6f2a.png";